import React from "react";
import DeveloperFormLayer from "../../components/Devs/DeveloperForm";

const DeveloperFormPage = () => {
  return (
    <>
       {/* Devs Table */}
        <DeveloperFormLayer />   
    </>
  );
};

export default DeveloperFormPage;
